import { useCV } from '../hooks/useCV'
import Section from './Section'
import CopyEmail from './CopyEmail'

const Contact = () => {
  const { contact } = useCV()

  const rows = [
    { label: 'LinkedIn', value: contact.linkedin?.replace(/^https?:\/\/(www\.)?/, ''), href: contact.linkedin },
    { label: 'GitHub', value: contact.github?.replace(/^https?:\/\//, ''), href: contact.github },
    { label: 'Website', value: contact.website?.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, ''), href: contact.website },
    { label: 'Phone', value: contact.phone, href: contact.phone ? `tel:${contact.phone}` : undefined },
  ].filter((r) => r.href)

  return (
    <Section id="contact" title="Contact" note="Open to full-stack roles and interesting projects.">
      <CopyEmail
        email={contact.email}
        linkClassName="font-serif text-3xl sm:text-5xl font-medium tracking-tight underline underline-offset-8 decoration-accent decoration-2 hover:text-accent break-all"
      />

      <dl className="mt-12">
        {rows.map((row) => (
          <div key={row.label} className="grid grid-cols-[6rem_1fr] sm:grid-cols-[8rem_1fr] gap-4 py-3 border-b border-rule">
            <dt className="text-mute">{row.label}</dt>
            <dd>
              <a
                href={row.href}
                target={row.href?.startsWith('http') ? '_blank' : undefined}
                rel="noopener noreferrer"
                className="underline underline-offset-4 decoration-rule hover:decoration-accent break-all"
              >
                {row.value}
              </a>
            </dd>
          </div>
        ))}
      </dl>
    </Section>
  )
}

export default Contact
